import SearchButtonComponent from '../components/SearchButton/viewer/SearchButton';
import SearchButtonController from '../components/SearchButton/viewer/SearchButton.controller';


const SearchButton = {
  component: SearchButtonComponent,
  controller: SearchButtonController
};


export const components = {
  ['SearchButton']: SearchButton
};

